export default "__VITE_ASSET__85898435__"